export const HAMBURGER_MENU_ITEMS_SET = 'AccessControl/hamburger-menu-items-set';
export const PERIOD_DATE_SET = 'AccessControl/period-date-set';
export const APP_INIT = 'AccessControl/app-init';
